import React from 'react';
import SEOHead from '../components/SEOHead';
import { OrganizationSchema, CourseSchema } from '../components/StructuredData';
import HeroSection from '../components/HeroSection';
import TrustSection from '../components/TrustSection';
import VideoSection from '../components/VideoSection';
import AdvantagesSection from '../components/AdvantagesSection';
import PricingSection from '../components/PricingSection';
import FAQSection from '../components/FAQSection';
import StepsSection from '../components/StepsSection';
import ContactSection from '../components/ContactSection';

const HomePage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="EU AI Act Training Platform - KI-Kompetenznachweis in 45 Minuten"
        description="Werden Sie in 45 Minuten compliant mit dem EU AI Act. Online-Schulung mit automatischem Abschlusstest und Zertifikat. Sofort einsatzbereit für nur 49,90 € zzgl. MwSt."
        keywords={[
          'EU AI Act',
          'KI-Schulung',
          'KI-Kompetenz',
          'AI Zertifikat',
          'Künstliche Intelligenz Schulung',
          'KI-Kompetenznachweis',
          'AI Act Compliance',
          'Online-Kurs KI',
          'KI-Training',
          'Artificial Intelligence Act'
        ]}
        canonicalUrl="/"
      />
      <OrganizationSchema />
      <CourseSchema />
      <div>
      <HeroSection />
      <TrustSection />
      <VideoSection />
      <AdvantagesSection />
      <PricingSection />
      <FAQSection />
      <StepsSection />
      <ContactSection />
    </div>
    </>
  );
};

export default HomePage;